import { Box } from '@mui/material'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { makeChildRoute } from '../../utils/CreateChildRoute'
import { LinkResolutionPage } from './LinkResolution'
import { ReCaptchaEnterpriseValidation } from './recaptcha-enterprise/RecaptchaEnterprisePage'

export const LinkRouter = () => {
	const { path } = useRouteMatch()

	return (
		<Switch>
			<Route path={makeChildRoute('_recaptcha', path)}>
				<ReCaptchaEnterpriseValidation />
			</Route>

			<Route path={makeChildRoute(':linkId', path)}>
				<LinkResolutionPage />
			</Route>

			<Box>404</Box>
		</Switch>
	)
}
